import React, { Component } from 'react';
import { connect } from 'react-redux';
import PlanningBaseVieForm from './PlanningBaseVieForm';
import PlanningElectrovanneForm from './PlanningElectrovanneForm';
import { createPlanningPayload } from '../../../../services/utils/planningDefaults';
import {
  getFunctionInformation,
  createView,
  updateViewPlanning,
  getTasksFromViewPlanning,
} from 'services/api';
import FormulaireSelectionProjet from '../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import Bouton from '../../../UI/Bouton/Bouton';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import { IsArrayString } from '../../../../ressources/functionJS/IsArrayString';
import { jsDictionaryEquals } from '../../../../ressources/functionJS/jsDictionaryEquals';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as glossaire_pattern from '../../../../ressources/glossaires/glossaire_pattern';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../../services/actions';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireVue.module.scss';
import { AiOutlineCheck } from 'react-icons/ai';
import { glossaire_type_de_vue } from '../../../../ressources/glossaires/glossaire_type_de_vue';
import { getAllCapteurByProjectId } from 'services/api.ts';

const formFields = [
  { name: 'view_name', pattern: glossaire_pattern.text },
  { name: 'view_title' },
  { name: 'update_time', pattern: glossaire_pattern.integer },
  { name: 'view_projection', pattern: glossaire_pattern.text },
  { name: 'view_bound_coordinates', pattern: glossaire_pattern.array },
  { name: 'view_zoom_levels', pattern: glossaire_pattern.array },
  { name: 'view_copyright', pattern: glossaire_pattern.text },
  { name: 'view_flag_fix_pos', pattern: glossaire_pattern.text },
  { name: 'is_clustered', pattern: glossaire_pattern.boolean },
  { name: 'is_main_view', pattern: glossaire_pattern.boolean },
  { name: 'is_visible', pattern: glossaire_pattern.boolean },
];
class FormulaireVue extends Component {
  state = {
    // paramètres par défaut de la vue
    selectedSensors: [], // Add this line
    view_name: '',
    view_title: '',
    update_time: null,
    view_projection: 1,
    view_bound_coordinates: [
      [0, 0],
      [0, 0],
    ],
    view_zoom_levels: [0, 1],
    view_copyright: '',
    view_flag_fix_pos: 0,
    is_clustered: 1,
    is_main_view: 1,
    is_visible: 1,
    view_type: 1,
    project_id: '',
    // Champs planning
    name: '',
    description: '',
    tasks: [],
  };

  componentDidMount() {
    if (this.props !== undefined && this.props.preconfigurerVue === undefined) {
      this.setState({
        // paramètres par défaut de la vue (voir ci-dessus)
        ...this.state,
      });
    } else if (
      this.props !== undefined &&
      this.props.preconfigurerVue !== undefined
    ) {
      this.setState({
        // pré-configuration du formulaire
        ...this.state,
        ...this.props.preconfigurerVue,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props !== undefined &&
      prevProps.preconfigurerVue !== this.props.preconfigurerVue &&
      this.props.preconfigurerVue === undefined
    ) {
      this.setState({
        // à faire: paramètres par défaut du graphique
        ...this.state,
      });
    } else if (
      this.props !== undefined &&
      this.props.preconfigurerVue !== undefined &&
      !jsDictionaryEquals(
        prevProps.preconfigurerVue,
        this.props.preconfigurerVue
      )
    ) {
      this.setState({
        // à faire: pré-configuration du formulaire
        ...this.state,
        ...this.props.preconfigurerVue,
      });
    }
  }

  updateSelectedSensors = (sensors) => {
    this.setState({ selectedSensors: sensors });
  };

  // Méthode pour vérifier si c'est un type planning
  isPlanningType = () => {
    return this.state.view_type === 6 || this.state.view_type === 5;
  };

  // Méthode pour rendre le select de type de vue
  renderViewTypeSelect = () => {
    return (
      <div className={[s.col_6, styles.style].join(' ')}>
        <span className={[styles.stil2].join(' ')}>
          {checkMot('type_de_vue')}
        </span>
        <select
          value={this.state.view_type}
          onChange={(event) => this.gererEtatDeCibleName(event)}
          name="view_type"
          className={[s.custom_select, s.mr_sm_2].join(' ')}
          disabled={this.props.affichageProfil === true}
        >
          {Object.keys(glossaire_type_de_vue).map((cleTypeDVue) => {
            return (
              <option
                key={cleTypeDVue}
                value={glossaire_type_de_vue[cleTypeDVue]}
              >
                {checkMot(cleTypeDVue)}
              </option>
            );
          })}
        </select>
      </div>
    );
  };
  // Méthode de rappel pour recevoir les données des composants enfants
  handlePlanningDataChange = (planningData) => {
    this.setState({
      ...planningData,
    });
  };

  // Méthode pour valider les données de planning
  validatePlanningData = () => {
    const requiredFields = ['project_id', 'view_name'];
    const missingFields = requiredFields.filter(
      (field) => !this.state[field] || this.state[field] === ''
    );

    if (missingFields.length > 0) {
      console.error('Champs obligatoires manquants:', missingFields);
      return false;
    }

    return true;
  };

  // Rendre le formulaire basé sur le type
  renderFormByType = () => {
    switch (parseInt(this.state.view_type)) {
      case glossaire_type_de_vue.planning_base_vie: // planning_base_vie
        return (
          <div className={styles.formContainer}>
            <div className={`${s.form_row} ${s.align_items_start}`}>
              <div className={`${s.col_12} ${styles.style}`}>
                <span className={[styles.stil2].join(' ')}>
                  {checkMot('type_de_vue')}
                </span>
                <select
                  value={this.state.view_type}
                  onChange={(event) => this.gererEtatDeCibleName(event)}
                  name="view_type"
                  className={[s.custom_select, s.mr_sm_2].join(' ')}
                  disabled={this.props.affichageProfil === true}
                >
                  {Object.keys(glossaire_type_de_vue).map((cleTypeDVue) => {
                    return (
                      <option
                        key={cleTypeDVue}
                        value={glossaire_type_de_vue[cleTypeDVue]}
                      >
                        {checkMot(cleTypeDVue)}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <PlanningBaseVieForm
              affichageProfil={this.props.affichageProfil}
              project_id={this.state.project_id}
              view_name={this.state.view_name}
              viewId={this.props.view_id}
              description={this.state.description}
              onDataChange={this.handlePlanningDataChange}
              selectedSensors={this.state.selectedSensors}
              setSelectedSensors={this.updateSelectedSensors}
            />
          </div>
        );

      case glossaire_type_de_vue.planning_electrovanne: // planning_electrovanne
        return (
          <div className={styles.formContainer}>
            <div className={`${s.form_row} ${s.align_items_start}`}>
              <div className={`${s.col_12} ${styles.style}`}>
                <span className={[styles.stil2].join(' ')}>
                  {checkMot('type_de_vue')}
                </span>
                <select
                  value={this.state.view_type}
                  onChange={(event) => this.gererEtatDeCibleName(event)}
                  name="view_type"
                  className={[s.custom_select, s.mr_sm_2].join(' ')}
                  disabled={this.props.affichageProfil === true}
                >
                  {Object.keys(glossaire_type_de_vue).map((cleTypeDVue) => {
                    return (
                      <option
                        key={cleTypeDVue}
                        value={glossaire_type_de_vue[cleTypeDVue]}
                      >
                        {checkMot(cleTypeDVue)}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <PlanningElectrovanneForm
              affichageProfil={this.props.affichageProfil}
              project_id={this.state.project_id}
              view_name={this.state.view_name}
              viewId={this.props.view_id}
              description={this.state.description}
              onDataChange={this.handlePlanningDataChange}
              selectedSensors={this.state.selectedSensors}
              setSelectedSensors={this.updateSelectedSensors}
            />
          </div>
        );

      default:
        return this.renderStandardForm();
    }
  };

  // Formulaire standard pour les autres types
  renderStandardForm = () => {
    return (
      <div className={[s.form_row, s.align_items_center].join(' ')}>
        {/* <FormulaireSelectionProjet
          affichageProfil={this.props.affichageProfil}
          gererProjetId={this.gererProjetId}
          preconfigurerProjetId={this.state.project_id}
        />
        {this.renderViewTypeSelect()} */}
        <div className={[s.form_row, s.align_items_center].join(' ')}>
          <FormulaireSelectionProjet
            affichageProfil={this.props.affichageProfil}
            gererProjetId={this.gererProjetId}
            preconfigurerProjetId={this.state.project_id}
          />
          {this.renderViewTypeSelect()}
          {formFields.map((field) =>
            this.affichageFormulaire(
              s.col_12,
              field.name,
              checkMot(field.name),
              field.pattern
            )
          )}
        </div>
      </div>
    );
  };

  gererEnvoi = async () => {
    let formulaireVue;
    let sensorsIdList = [];
    let sensorsDevuiList = [];
    if (this.state.view_type === 6 || this.state.view_type === 5) {
      // Pour les formulaires planning - utiliser createPlanningPayload avec la configuration par défaut
      const formData = {
        project_id: parseInt(this.state.project_id),
        view_type: parseInt(this.state.view_type),
        view_name: this.state.view_name,
        description: this.state.description || '',
        selectedSensors: this.state.selectedSensors || [],
        defaultConfig: this.state.defaultConfig,
      };
      this.state.selectedSensors.map((sensor) => {
        sensorsIdList.push(sensor.sensor_id);
        sensorsDevuiList.push(sensor.remarks);
      });
      formulaireVue = createPlanningPayload(formData);
    } else {
      // Formulaire standard complet
      formulaireVue = {
        project_id: parseInt(this.state.project_id),
        view_type: parseInt(this.state.view_type),
        view_name: this.state.view_name,
        view_title: this.state.view_title,
        update_time: parseInt(this.state.update_time),
        view_projection: parseInt(this.state.view_projection),
        view_bound_coordinates: IsArrayString(
          this.state.view_bound_coordinates,
          [
            [0, 0],
            [0, 0],
          ]
        ),
        view_zoom_levels: IsArrayString(this.state.view_zoom_levels, [0, 1]),
        view_copyright: this.state.view_copyright,
        view_flag_fix_pos: parseInt(this.state.view_flag_fix_pos),
        is_clustered: parseInt(this.state.is_clustered),
        is_main_view: parseInt(this.state.is_main_view),
        is_visible: parseInt(this.state.is_visible),
      };
    }

    // Validation pour les plannings
    if (this.state.view_type === 6 || this.state.view_type === 5) {
      if (!this.validatePlanningData()) {
        console.error('Validation échouée pour les données de planning');
        return;
      }
    }

    // Envoi de la requête
    if (this.props !== undefined && this.props.preconfigurerVue === undefined) {
      if (this.state.view_type === 5 || this.state.view_type === 6) {
        // call pour chopper le function ID
        const getFunctionArguments = await getFunctionInformation({
          viewType: this.state.view_type,
        });
        const viewInfo = await createView({
          request_type: 10602,
          project_id: this.state.project_id,
          view_type: this.state.view_type,
          view_name: this.state.view_name,
          view_title: this.state.view_name,
          update_time: null,
          view_projection: 0,
          view_bound_coordinates: [
            [0, 0],
            [0, 0],
          ],
          view_zoom_levels: [0, 0],
          view_copyright: '',
          view_flag_fix_pos: 0,
          is_clustered: 0,
          is_main_view: 0,
          is_visible: 0,
        });
        const functionInfo = getFunctionArguments.data[0];
        const argumentsList = [
          {
            Position_in_arg: 1,
            Value: functionInfo.arguments_definition[0].options[0]?.value || '',
          },
          { Position_in_arg: 2, Value: sensorsDevuiList },
        ];
        const payload = {
          project_id: this.state.project_id,
          tasks: [...Array(7)].map((_, i) => {
            return {
              name: this.state.view_name,
              type: 'scheduled',
              function_id: functionInfo.idFunction,
              group_taches: sensorsDevuiList.join(','),
              cron_year: '*',
              cron_month: '*',
              cron_day: '*',
              cron_week: '*',
              cron_day_of_week: '' + i,
              cron_hour: '0',
              cron_minute: '0',
              cron_second: '0',
              cron_start_day: new Date().toISOString().split('T')[0],
              cron_end_date: new Date(
                new Date().setFullYear(new Date().getFullYear() + 1)
              )
                .toISOString()
                .split('T')[0],
              view_id: viewInfo.data.view_id,
              state: 1,
              sensors_list: sensorsIdList.join(','),
              id_arguments: argumentsList,
            };
          }),
        };
        this.props.reqCreerPlanning(payload);
        this.props.recupererListeVues(this.props.filtre_projects_list_id);
      } else {
        this.props.reqCreerVue(formulaireVue);
      }
    } else {
      if (this.state.view_type === 5 || this.state.view_type === 6) {
        /* 
        1. Récupérer toutes les tâches de la vue et update dans chaque taches la liste des id de capteurs dans les arguments
           sensors_list à la racine avec les id sensor et 
           les champs remarque des sensors dans l'argument position correspondant à la liste de DEVUI
        2. Formatter les données
        3. Update la vue avec les nouvelles informations avec le call habituel (request_type:10607)
        */
        this.props.reqModifierVue({
          request_type: 10607,
          view_id: parseInt(this.props.preconfigurerVue.view_id),
          project_id: this.state.project_id,
          view_type: this.state.view_type,
          view_name: this.state.view_name,
          view_title: this.state.view_name,
          update_time: null,
          view_projection: 0,
          view_bound_coordinates: [
            [0, 0],
            [0, 0],
          ],
          view_zoom_levels: [0, 0],
          view_copyright: '',
          view_flag_fix_pos: 0,
          is_clustered: 0,
          is_main_view: 0,
          is_visible: 0,
        });
        await getTasksFromViewPlanning({
          viewId: this.props.preconfigurerVue.view_id,
        }).then(async (response) => {
          // TODO: Problème ici, quand on ajoute, supprime un capteurs, il faut bien ajouter/enlever en différenciant les taches auto manuel et exception
          const actualTasks = response.data.tasks;
          const actualTasksSensorsId = actualTasks
            .find((task) => task.state === 0 || task.state === 1)
            .sensors_list.split(',');
          let removedSensors = { sId: [], mode: '-' };
          const updatesOnSensors = [];
          const responseCapteurs = await getAllCapteurByProjectId({
            projects_id: this.props.filtre_projects_list_id,
          });
          const listeCapteurs = responseCapteurs.data.sensors_list;
          actualTasksSensorsId.forEach((sensorId) => {
            if (!sensorsIdList.includes(parseInt(sensorId))) {
              updatesOnSensors.push({ sensorId, mode: '-' });
              removedSensors.sId.push(sensorId);
            }
          });
          sensorsIdList.forEach((sensorId) => {
            if (!actualTasksSensorsId.includes('' + sensorId)) {
              updatesOnSensors.push({ sensorId, mode: '+' });
            }
          });
          const removedDevuiList = [];
          removedSensors = removedSensors.sId.map((sId) => {
            const removedSensor = listeCapteurs.find(
              (sensor) => sensor.sensor_id == sId
            );

            if (removedSensor) {
              removedDevuiList.push(removedSensor.remarks);
              return { sId, devUI: removedSensor.remarks };
            }
          });
          const manualTasks = [];
          const actualTasksWithoutRemovedManual = actualTasks.filter((task) => {
            console.log(
              'task.id_arguments[1].Value',
              task.id_arguments[1].Value
            );
            console.log('removedDevuiList', removedDevuiList);
            if (
              task.state === 2 &&
              removedDevuiList.includes(
                JSON.parse(task.id_arguments[1].Value)[0]
              )
            ) {
              return false;
            } else if (task.state === 2) {
              manualTasks.push(JSON.parse(task.id_arguments[1].Value)[0]);
              return true;
            } else {
              return true;
            }
          });
          console.log('manualTasks', manualTasks);
          console.log('sensorsDevuiList', sensorsDevuiList);
          console.log('actualTasks5', actualTasks);
          console.log(
            'actualTasksWithoutRemovedManual',
            actualTasksWithoutRemovedManual
          );
          sensorsDevuiList = sensorsDevuiList.filter(
            (devui) => !manualTasks.includes(devui)
          );
          console.log('filteredSensorsDevuiList', sensorsDevuiList);
          console.log('sensorsDevuiList after filter', sensorsDevuiList);
          //TODO check if the there is manual tasks, if there is, don't put it's devui in the devuilist of the auto tasks
          const updatedTasks = {
            project_id: this.state.project_id,
            tasks: actualTasksWithoutRemovedManual.map((task) => {
              return {
                ...task,
                sensors_list: sensorsIdList.join(','),
                id_arguments: task.id_arguments.map((arg) => {
                  if (arg.Position_in_arg === 2) {
                    if (task.state !== 2) {
                      return {
                        ...arg,
                        Value: sensorsDevuiList,
                      };
                    } else {
                      return arg;
                    }
                  } else {
                    return arg;
                  }
                }),
              };
            }),
          };

          console.log('updatedTasks', updatedTasks);
          updateViewPlanning(updatedTasks);
        });
      } else {
        formulaireVue['view_id'] = parseInt(
          this.props.preconfigurerVue.view_id
        );
        this.props.reqModifierVue(formulaireVue);
      }
    }
  };

  gererEtatDeCibleName = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      if (name === 'view_type') {
        this.forceUpdate();
      }
    });
  };

  gererArrayEtatDeCibleName = (event) =>
    this.setState({
      [event.target.name]: IsArrayString(event.target.value),
    });

  gererProjetId = (projetId) => {
    this.setState({ project_id: projetId });
  };

  affichageFormulaire = (style, label_state, label_name, pattern) => {
    /**
     * permet d'afficher un composant input de gestion de la modification
     */

    switch (pattern) {
      case glossaire_pattern.array:
        return (
          <div className={[s.col_6, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={[s.form_control].join(' ')}
              placeholder={label_state}
              name={label_state}
              value={
                this.props.preconfigurerVue !== undefined
                  ? JSON.stringify(this.state[label_state])
                  : null
              }
              disabled={this.props.affichageProfil === true}
              onChange={(event) => this.gererArrayEtatDeCibleName(event)}
            />
          </div>
        );
      default:
        return (
          <div className={[s.col_6, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={[s.form_control].join(' ')}
              placeholder={label_state}
              name={label_state}
              value={
                this.props.preconfigurerVue !== undefined
                  ? this.state[label_state]
                  : null
              }
              disabled={this.props.affichageProfil === true}
              onChange={(event) => this.gererEtatDeCibleName(event)}
            />
          </div>
        );
    }
  };

  render() {
    return (
      <>
        <div className={[s.row].join(' ')}>
          <div className={styles.ConteneurInfo}>
            <div className={[s.container, s.text_left].join(' ')}>
              <form onSubmit={(event) => event.preventDefault()}>
                <div className={s.form_group}>
                  {/* Rendre le formulaire basé sur le type */}
                  {this.renderFormByType()}
                </div>

                {/* Boutons d'action */}
                {this.props.affichageProfil === true ? null : (
                  <div className={s.form_group}>
                    <div
                      className={[s.d_flex, s.justify_content_between].join(
                        ' '
                      )}
                    >
                      <div>
                        <Bouton
                          type={type_btn.danger}
                          cliquer={(e) => {
                            e.preventDefault();
                            this.props.annuler();
                          }}
                        >
                          {checkMot('annuler')}
                        </Bouton>
                      </div>
                      <div
                        className={[s.d_flex, s.justify_content_between].join(
                          ' '
                        )}
                      >
                        {this.props !== undefined &&
                        this.props.preconfigurerVue === undefined ? (
                          <AttenteRequete
                            request_type={requestType.creer_une_vue}
                            str={checkMot('creation_en_cour')}
                          >
                            <Bouton
                              type={type_btn.succes}
                              cliquer={() => this.gererEnvoi()}
                            >
                              <AiOutlineCheck />
                              {checkMot('creer')}
                            </Bouton>
                          </AttenteRequete>
                        ) : (
                          <AttenteRequete
                            request_type={requestType.modifier_une_vue}
                            str={checkMot('modification_en_cour')}
                          >
                            <Bouton
                              type={type_btn.succes}
                              cliquer={() => this.gererEnvoi()}
                            >
                              {checkMot('enregistrer')}
                            </Bouton>
                          </AttenteRequete>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filtre_projects_list_id: state.authentifie.filtre_projects_list_id,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    recupererListeCapteurs: (filtre_projects_list_id) =>
      dispatch(actions.reqRecupererListeCapteurs(filtre_projects_list_id)),
    recupererListeVues: (filtre_projects_list_id) =>
      dispatch(actions.reqRecupererListeVues(filtre_projects_list_id)),
    reqCreerVue: (formulaireGrapheT_X) =>
      dispatch(actions.reqCreerVue(formulaireGrapheT_X)),
    reqCreerPlanning: (formulairePlanning) =>
      dispatch(actions.reqCreerPlanning(formulairePlanning)),
    reqModifierVue: (formulaireGrapheT_X) =>
      dispatch(actions.reqModifierVue(ownProps.view_id, formulaireGrapheT_X)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormulaireVue);
